import { useEffect, useState } from "react";
import { TbArrowBadgeRightFilled } from "react-icons/tb";
import Input from "../../Components/Input/Input";
import DocumentuploadSection from "../../Templets/DocumentuploadSection/DocumentuploadSection";
import { DocUpload, FooterInfo, LicenseInfo } from "./RequestSupport.config.js";
import "./RequestSupport.scss";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { getUserMobile, getUserName } from "../../../CommonFunction/GetUserInfo";
import { AllCount } from "../../../Utils/AllPagesQuriesAndMutations";
import Button from "../../Components/Button/Button";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
const $createInput = gql`
  mutation CreateTicket($createInput: RequestSupportInput!) {
    createSupportRequest(createInput: $createInput) {
      id
    }
  }
`;
interface formdata {
  Name: string;
  Mobile_No?: number;
  Issue_Related_To: string;
  Issue_Subject: string;
  Issue_Details: string;
}
const getUserDetails = async () => {
  let userName = await getUserName();
  let Mob = await getUserMobile();
  return { userName, Mob };
};
const initialState: formdata = {
  Name: "",
  // Mobile_No:,
  Issue_Related_To: "",
  Issue_Subject: "",
  Issue_Details: "",
};
export const RequestSupport = ({ fielddata }) => {
  const [CreateRequest] = useMutation($createInput);
  const FormData = useSelector((store: any) => store.FormFieldData);
  const [fileInfo, setFileInfo] = useState({});
  const [formvalues, setvalues] = useState<formdata>(initialState);
  const [fetchedUserDetails, setFetchedUserDetails] = useState({
    userName: "",
    Mob: 0,
  });
  const { data: countData } = useQuery(AllCount);
  const HandleInputChange = (e) => {
    console.log(e, "wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww")
    setvalues({ ...formvalues, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      const userData = await getUserDetails();
      setFetchedUserDetails(userData);
      setvalues((prevValues) => ({
        ...prevValues,
        Name: userData.userName, // Update state when userName is fetched
        Mobile_No: userData.Mob,
      }));
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    setFileInfo(FormData?.fielddata?.Files);
  }, [FormData]);
  const submit = () => {
    let data = { ...formvalues, ...fileInfo };
    CreateRequest({ variables: { createInput: data } })
      .then((res) => {
        SuccessToast("Tiket created");
        setvalues(initialState);
      })
      .catch((err) => {
        ErrorToast("Something went wrong! Please Check fields and try again.");
      });
  };

  return (
    <>
      <div className="RequestSupportContainer">
        <h3>Support Request & License Info.</h3>
        <div className="subContainer">
          <div className="RequestSupportandLicenseeContent">
            <div className="RequestSuportNavbar">
              <div>
                <NavLink className="Links" to={"/RequestSupport/UnReadIssues"}>
                  <span>{countData?.getAllRequestSupportStatusCount?.Unread}</span>
                  <p>Unread Issue</p>
                </NavLink>
              </div>
              <div>
                <NavLink className="Links" to={"/RequestSupport/OpenIssues"}>
                  <span>{countData?.getAllRequestSupportStatusCount?.Open}</span>
                  <p>Open Issue</p>
                </NavLink>
              </div>
              <div>
                <NavLink className="Links" to={"/RequestSupport/HoldIssues"}>
                  <span>{countData?.getAllRequestSupportStatusCount?.Hold}</span>
                  <p>Hold Issue</p>
                </NavLink>
              </div>
              <div>
                <NavLink className="Links" to={"/RequestSupport/ClosedIsues"}>
                  <span>{countData?.getAllRequestSupportStatusCount?.Closed}</span>
                  <p>Closed Issue</p>
                </NavLink>
              </div>
            </div>
            <div className="Requectsupportcontainer">
              <div className="SupportHeading">
                <span>
                  <TbArrowBadgeRightFilled />
                </span>
                Support Request
              </div>
              <div>
                <div className="firstFormSection">
                  <div>
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig=""
                      value={formvalues.Name}
                      type={"text"}
                      disabled={true}
                      handleInputChange={(evt) => {
                        HandleInputChange(evt);
                      }}
                      handleBlur={() => {}}
                      name={"Name"}
                      TypeOfPortal={""}
                      modalform={true}
                      Section_Type=""
                      className=""
                      touched={false}
                      error={""}
                      label=""
                      max={Infinity}
                      JurnalDropdown={false}
                      transactions={false}
                      PaymentProcess=""
                      notSearchable=""
                      onFocus={() => {}}
                    />
                  </div>
                  <div>
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig=""
                      value={formvalues.Mobile_No}
                      type={"number"}
                      disabled={true}
                      handleInputChange={(evt) => {
                        HandleInputChange(evt);
                      }}
                      handleBlur={() => {}}
                      name={"Mobile_No"}
                      TypeOfPortal={""}
                      modalform={true}
                      Section_Type=""
                      className=""
                      touched={false}
                      error={""}
                      label="Mobile No"
                      max={Infinity}
                      JurnalDropdown={false}
                      transactions={false}
                      PaymentProcess=""
                      notSearchable=""
                      onFocus={() => {}}
                    />
                  </div>
                  <div>
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig=""
                      value={formvalues.Issue_Related_To}
                      type={"Dropdown"}
                      disabled={false}
                      handleInputChange={(evt) => {
                        // HandleInputChange(evt);
                         HandleInputChange({ target: { name: "Issue_Related_To", value: evt.target.value } })
                      }}
                      handleBlur={() => {}}
                      name={"Issue_Related_To"}
                      TypeOfPortal={""}
                      modalform={true}
                      Section_Type=""
                      className=""
                      touched={false}
                      error={""}
                      dropdowndata={[
                        "GST Related",
                        "Printing Related",
                        "Sales Inquiry",
                        "Accounting Effect Isssue",
                        "New Development",
                        "ERROR/Other",
                      ]}
                      label="Issue Related To"
                      max={Infinity}
                      JurnalDropdown={false}
                      transactions={false}
                      PaymentProcess=""
                      notSearchable=""
                      onFocus={() => {}}
                    />
                  </div>
                </div>
                <div className="otherFormSection">
                  <div>
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig=""
                      value={formvalues.Issue_Subject}
                      type={"text"}
                      disabled={false}
                      handleInputChange={(evt) => {
                        HandleInputChange(evt);
                      }}
                      handleBlur={() => {}}
                      name={"Issue_Subject"}
                      TypeOfPortal={""}
                      modalform={true}
                      Section_Type=""
                      className=""
                      touched={false}
                      error={""}
                      label="Issue Subject"
                      max={Infinity}
                      JurnalDropdown={false}
                      transactions={false}
                      PaymentProcess=""
                      notSearchable=""
                      onFocus={() => {}}
                    />
                  </div>
                </div>
                <div className="otherFormSection">
                  <div>
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig=""
                      value={formvalues.Issue_Details}
                      type={"textarea"}
                      disabled={false}
                      handleInputChange={(evt) => {
                        HandleInputChange(evt);
                      }}
                      handleBlur={() => {}}
                      name={"Issue_Details"}
                      TypeOfPortal={""}
                      modalform={true}
                      Section_Type=""
                      className=""
                      touched={false}
                      error={""}
                      label="Issue Details"
                      max={Infinity}
                      JurnalDropdown={false}
                      transactions={false}
                      PaymentProcess=""
                      notSearchable=""
                      onFocus={() => {}}
                    />
                  </div>
                </div>
                <div className="Attachment">
                  <div className="ImageHeading">Attachment</div>
                  <div className="RequestSupportImages">
                    <DocumentuploadSection
                      fielddata={fielddata}
                      allFieldsData={{}}
                      data={DocUpload}
                      TypeOfPortal={"Request Support"}
                      LoadForm={true}
                      values={fielddata}
                    />
                  </div>
                </div>
                <div className="buttonContainer1">
                  <Button action={submit} text="Add Request" name="AddRow" type="" children="" disabled={false} />
                  <Button
                    action={() => {
                      setvalues({
                        ...initialState,
                        Name: fetchedUserDetails.userName,
                        Mobile_No: fetchedUserDetails.Mob,
                      });
                    }}
                    text="Cancel"
                    name="AddRow"
                    type=""
                    children=""
                    disabled={false}
                  />
                </div>
              </div>
            </div>
            <div className="LicenseInfo">
              {LicenseInfo?.map((el, i) => {
                return (
                  <>
                    <div>
                      <span>{el.title}</span>
                      <p>{el.value}</p>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </div>
        <div className="RequestSupportFooter">
          <div>
            {FooterInfo?.map((el, i) => {
              return (
                <>
                  <div>
                    {el.icon}
                    <span>{el.title}:</span>
                    <p>{el.value}</p>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
